<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="usersData"
      style="width: 100.1%;"
    >
    </Table>
    <!-- 重置密码 -->
    <reset-password
      v-if="resetPasswordVisible"
      ref="resetPassword"
    ></reset-password>
    <!-- 操作日志详情 -->
    <configuration-management-operation-log
      v-if="isShowOperationLog"
      ref="configurationManagementOperationLog"
    ></configuration-management-operation-log>
    <!-- 删除 -->
    <Modal v-model="usersDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>
          {{ $t("alarms.common.sureDelete") }} {{ usersName }}
          {{ $t("alarms.common.what") }}?
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="removeUser()"
          >{{ $t("common.del") }}</Button
        >
      </div>
    </Modal>
    <!-- 编辑 -->
    <Modal
      v-model="usersEditmodal"
      :title="$t('permission_configuration_management.user.editUser')"
      :loading="loading"
      @on-ok="userSubmit('userEditForm')"
      @on-cancel="userReset('userEditForm')"
      :mask-closable="false"
      :okText="$t('permission_configuration_management.common.confirm')"
      :cancelText="$t('permission_configuration_management.common.cancel')"
    >
      <Form
        ref="userEditForm"
        :model="userEditForm"
        :label-width="100"
        :rules="ruleValidate"
      >
        <!-- 公司 -->
        <FormItem
          :label="$t('permission_configuration_management.account.company')"
          prop="companyId"
        >
          <div>{{ this.companyName }}</div>
        </FormItem>
        <!-- 用户名称 -->
        <FormItem
          :label="$t('permission_configuration_management.user.userName')"
          prop="name"
        >
          <Input
            v-model="userEditForm.name"
            placeholder="Enter something..."
            style="width:300px;"
          ></Input>
        </FormItem>
        <!-- 全名 -->
        <FormItem
          :label="$t('permission_configuration_management.user.fullName')"
          prop="fullName"
        >
          <Input
            v-model="userEditForm.fullName"
            placeholder="Enter something..."
            style="width:300px;"
          ></Input>
        </FormItem>
        <!-- 部门 -->
        <FormItem
          :label="$t('permission_configuration_management.user.department')"
          prop="department"
        >
          <Select
            v-model="userEditForm.department"
            style="width:300px;"
            @on-change="changeDepartment"
          >
            <Option
              :value="item.id"
              v-for="item in departmentList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <!-- 职务 -->
        <FormItem
          :label="$t('permission_configuration_management.user.position')"
          prop="position"
        >
          <Select v-model="userEditForm.position" style="width:300px;">
            <Option
              :value="item.id"
              v-for="item in positionList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <!-- 邮箱 -->
        <FormItem
          :label="$t('permission_configuration_management.user.email')"
          prop="email"
        >
          <Input
            v-model="userEditForm.email"
            placeholder="Enter something..."
            style="width:300px;"
          ></Input>
        </FormItem>
        <!-- 角色 -->
        <FormItem
          :label="$t('permission_configuration_management.user.role')"
          prop="role"
        >
          <Select v-model="userEditForm.role" style="width:300px;">
            <Option :value="item.id" v-for="item in roleList" :key="item.id">{{
              item.name
            }}</Option>
          </Select>
        </FormItem>
        <!-- 是否开启短信验证 -->
        <FormItem
          :label="
            $t('permission_configuration_management.user.SMSVerification')
          "
          prop="msgCode"
        >
          <RadioGroup v-model="msgCode" @on-change="handleChangeMsg">
            <Radio :label="$t('common.yes')"></Radio>
            <Radio :label="$t('common.no')"></Radio>
          </RadioGroup>
        </FormItem>
        <!-- 开启短信验证 手机号为必填项 -->
        <FormItem
          :label="$t('permission_configuration_management.smsLogin.telPhone')"
          v-if="msgCode == $t('common.yes')"
        >
          <div class="tel-container">
            <Select v-model="areaCode" placeholder="+86">
              <Option
                :value="a.phone_code"
                :key="index"
                v-for="(a, index) in AreaCodeArr"
                :label="'+' + a.phone_code"
              >
                <span
                  >{{ "+" + a.phone_code }}&nbsp;{{ a.chinese_name }} (
                  {{ a.english_name }} )
                </span>
              </Option>
            </Select>
            <Input
              v-model="userEditForm.phone"
              type="number"
              style="width:229px;"
              :placeholder="
                $t('permission_configuration_management.smsLogin.plaTelPhone')
              "
            ></Input>
          </div>
        </FormItem>
        <!-- 开启短信验证 验证码为必填项 -->
        <FormItem
          v-if="showCode"
          :label="
            $t('permission_configuration_management.smsLogin.verificationCode')
          "
        >
          <div class="tel-container">
            <Input
              v-model="userEditForm.code"
              type="number"
              :placeholder="
                $t(
                  'permission_configuration_management.smsLogin.plaVerificationCode'
                )
              "
              :style="$i18n.locale == 'zh' ? 'width:205px' : 'width:160px'"
            ></Input>
            <Button
              type="text"
              :disabled="disabled"
              @click="sendCode"
              class="btn-text"
            >
              {{ text }}
            </Button>
          </div>
          <p style="color:#ed4014">{{ this.getErrMsg }}</p>
        </FormItem>
      </Form>
    </Modal>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
import ResetPassword from "./ResetPassword.vue";
import ConfigurationManagementOperationLog from "../../common/ConfigurationManagementOperationLog.vue";
import AreaCode from "@/utils/AreaCode";
var tableUsersVue = {};
export default {
  name: "TableUsers",
  components: {
    ResetPassword,
    ConfigurationManagementOperationLog
  },
  data() {
    return {
      isShowOperationLog: false,
      resetPasswordVisible: false,
      companyName: "",
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      searchUserName: "",
      usersDelmodal: false,
      usersEditmodal: false,
      usersName: "",
      val: "",
      modal_loading: false,
      loading: true,
      userEditForm: {
        name: "",
        email: "",
        fullName: "",
        department: "",
        position: "",
        role: "",
        active: "",
        id: "",
        companyId: "",
        mfaStatus: 0,
        phone: "",
        code: ""
      },
      disabled: false,
      text: "",
      run: null,
      showCode: false,
      getPhone: "",
      msgCode: "",
      AreaCodeArr: [],
      areaCode: 86,
      getErrMsg: "",
      roleList: [],
      departmentList: [],
      positionList: [],
      companyIdList: [],
      columns: [
        {
          title: this.$t("permission_configuration_management.user.userName"),
          key: "name",
          render: (h, params) => {
            return h(
              "a",
              {
                style: {
                  textDecoration: "underline"
                },
                on: {
                  click: () => {
                    let department = params.row.department;
                    if (department != undefined) {
                      this.search(department);
                    }

                    this.usersEditmodal = true; //编辑账户弹出层
                    this.userEditForm.id = params.row.id;
                    // 用户名
                    this.userEditForm.name = params.row.name;
                    // 邮箱
                    this.userEditForm.email = params.row.email;
                    // 全名
                    this.userEditForm.fullName = params.row.fullName;
                    // 公司
                    this.userEditForm.companyId = params.row.companyId;
                    this.companyName = params.row.companyName;
                    // 部门
                    this.userEditForm.department = params.row.department;
                    // 职务
                    this.userEditForm.position = params.row.position;
                    //角色
                    this.$api.user
                      .queryRole("companyId", this.userEditForm.companyId)
                      .then(res => {
                        this.roleList = res.data;
                      });
                    this.userEditForm.role = params.row.role;
                    //状态
                    this.userEditForm.active = params.row.active;
                    // 是否开启短信验证
                    this.userEditForm.mfaStatus = params.row.mfaStatus ? 1 : 0;
                    this.msgCode = params.row.mfaStatus
                      ? this.$t("common.yes")
                      : this.$t("common.no");
                    if (this.userEditForm.mfaStatus == 1) {
                      let index = params.row.phone.lastIndexOf("\-");
                      // - 之前
                      this.areaCode = params.row.phone.substring(0, index);
                      // - 之后
                      this.userEditForm.phone = params.row.phone.substring(
                        index + 1,
                        params.row.phone.length
                      );
                      this.getPhone = params.row.phone.substring(
                        index + 1,
                        params.row.phone.length
                      );
                    } else {
                      this.getPhone = this.userEditForm.phone = "";
                      this.userEditForm.code = "";
                    }
                    this.getErrMsg = "";
                    this.showCode = false;
                  }
                }
              },
              params.row.name
            );
          }
        },
        {
          title: this.$t(
            "permission_configuration_management.user.companyName"
          ),
          key: "companyName"
        },
        {
          title: this.$t("permission_configuration_management.user.email"),
          key: "email"
        },
        {
          title: this.$t("permission_configuration_management.user.fullName"),
          key: "fullName"
        },
        {
          title: this.$t("permission_configuration_management.user.department"),
          key: "departmentName"
        },
        {
          title: this.$t("permission_configuration_management.user.position"),
          key: "positionName"
        },
        {
          title: this.$t("permission_configuration_management.user.role"),
          key: "roleName"
        },
        {
          title: this.$t(
            "permission_configuration_management.user.loginStatus"
          ),
          key: "isState"
        },
        {
          title: this.$t(
            "permission_configuration_management.user.accountStatus"
          ),
          key: "isActive"
        },
        {
          title: this.$t(
            "permission_configuration_management.user.SMSVerificationStatus"
          ),
          key: "mfaStatusName",
          width: 150
        },
        {
          title: this.$t("common.operation"),
          width: "280px",
          slot: "operations",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "success",
                    size: "small"
                  },
                  style: {
                    "margin-right": "5px"
                  },
                  on: {
                    click: () => {
                      this.logClick(params.row, params.index);
                    }
                  },
                  directives: [
                    {
                      name: "hasPermission",
                      value: new Array(
                        "permissionsConfigurationManagement:user:log"
                      )
                    }
                  ]
                },
                this.$t(
                  "permission_configuration_management.common.operationLog"
                )
              ),
              h(
                "i-switch",
                {
                  // 数据库0启用,1禁用
                  props: {
                    type: "primary",
                    size: "large",
                    value: params.row.active
                  },
                  style: {
                    "margin-right": "5px"
                  },
                  on: {
                    "on-change": () => {
                      this.switch(params.index);
                    }
                  }
                },
                [
                  h("span", {
                    slot: "open",
                    domProps: {
                      innerHTML: this.$t(
                        "permission_configuration_management.user.enable"
                      )
                    }
                  }),
                  h("span", {
                    slot: "close",
                    domProps: {
                      innerHTML: this.$t(
                        "permission_configuration_management.user.disable"
                      )
                    }
                  })
                ]
              ),
              h(
                "Button",
                {
                  props: {
                    type: "warning",
                    size: "small"
                  },
                  style: {
                    "margin-right": "5px"
                  },
                  on: {
                    click: () => {
                      this.rowClick(params.row, params.index);
                    }
                  },
                  directives: [
                    {
                      name: "hasPermission",
                      value: new Array(
                        "permissionsConfigurationManagement:user:reset"
                      )
                    }
                  ]
                },
                this.$t(
                  "permission_configuration_management.user.resetPassword"
                )
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.doDelete(params.index);
                      this.usersDelmodal = true;
                    }
                  },
                  directives: [
                    {
                      name: "hasPermission",
                      value: new Array(
                        "permissionsConfigurationManagement:user:delete"
                      )
                    }
                  ]
                },
                this.$t("permission_configuration_management.common.delete")
              )
            ]);
          }
        }
      ],
      ruleValidate: {
        name: [
          { required: true, message: this.$t("permission_configuration_management.user.pleaseInputUserName"), trigger: "blur" },
          {
            type: "string",
            message: this.$t("permission_configuration_management.user.userNameLength100"),
            pattern: "^.{1,100}$",
            trigger: "blur"
          }
        ],
        email: [
          { required: true, message: this.$t("permission_configuration_management.user.pleaseInputEmail"), trigger: "blur" },
          { type: "email", message: this.$t("permission_configuration_management.user.emailFormatError"), trigger: "blur" }
        ],
        fullName: [
          { required: true, message: this.$t("permission_configuration_management.user.pleaseInputFullName"), trigger: "blur" },
          {
            type: "string",
            message: this.$t("permission_configuration_management.user.fullNameLength100"),
            pattern: "^.{1,100}$",
            trigger: "blur"
          }
        ],
        department: [
          {
            required: true,
            message: this.$t("permission_configuration_management.user.pleaseSelectDepartment"),
            trigger: "change",
            type: "number"
          }
        ],
        companyId: [
          {
            required: true,
            message: this.$t("permission_configuration_management.user.pleaseSelectCompany"),
            trigger: "change",
            type: "number"
          }
        ],
        position: [
          {
            required: true,
            message: this.$t("permission_configuration_management.user.pleaseSelectPosition"),
            trigger: "change",
            type: "number"
          }
        ],
        role: [
          {
            required: false,
            message: this.$t("permission_configuration_management.user.pleaseSelectRole"),
            trigger: "change",
            type: "number"
          }
        ]
      },
      usersData: []
    };
  },
  beforeCreate: function() {
    tableUsersVue = this;
  },
  mounted: function() {
    tableUsersVue.getUsersData();
    this.AreaCodeArr = AreaCode.list;
    this.text = this.$t(
      "permission_configuration_management.smsLogin.getVerificationCode"
    );
  },
  watch: {
    "userEditForm.phone": {
      handler(Val) {
        if (this.getPhone != Val) {
          this.showCode = true;
        } else {
          this.showCode = false;
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    handleChangeMsg(data) {
      if (data == this.$t("common.yes")) {
        this.showCode = true;
      } else {
        this.showCode = false;
      }
    },
    sendCode() {
      if (!this.userEditForm.phone) {
        this.$Message.error(
          this.$t("permission_configuration_management.smsLogin.plaTelPhone")
        );
        return;
      }
      this.$api.user
        .sendSmsCode({
          id: this.userEditForm.id,
          phone: this.areaCode + "-" + this.userEditForm.phone
        })
        .then(res => {
          this.countDown();
          this.getErrMsg = "";
        })
        .catch(err => {
          this.getErrMsg = err.data.message;
        });
    },
    countDown() {
      if (this.disabled) return;
      this.disabled = true;
      let n = 60;
      this.text =
        n +
        "s" +
        this.$t("permission_configuration_management.smsLogin.surplusTime");
      this.run = setInterval(() => {
        n = n - 1;
        if (n < 1) {
          this.disabled = false;
          this.text = this.$t(
            "permission_configuration_management.smsLogin.Reacquire"
          );
          clearInterval(this.run);
          return;
        }
        this.text =
          n +
          "s" +
          this.$t("permission_configuration_management.smsLogin.surplusTime");
        if (
          this.text <
          0 +
            "s" +
            this.$t("permission_configuration_management.smsLogin.surplusTime")
        ) {
          this.disabled = false;
          this.text = this.$t(
            "permission_configuration_management.smsLogin.Reacquire"
          );
        }
      }, 1000);
    },
    showAll: function() {
      tableUsersVue.getUsersData();
    },
    // 分页显示数据
    getUsersData: function() {
      eventBus.$on("userNames", function(val) {
        tableUsersVue.val = val;
      });
      eventBus.$on("companyId", function(val) {
        tableUsersVue.companyId = val;
      });
      // 账户列表分页
      clearInterval(this.run);
      this.disabled = false;
      this.$api.user
        .pageUser({
          companyId: tableUsersVue.companyId,
          userName: tableUsersVue.val,
          pageNum: this.current,
          pageSize: this.pageSize
        })
        .then(res => {
          this.usersData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
          // 显示状态
          for (var i = 0; i < this.usersData.length; i++) {
            // 登陆状态
            if (this.usersData[i].state == 1) {
              this.usersData[i].isState = this.$t(
                "permission_configuration_management.user.onLine"
              );
            } else if (this.usersData[i].state == 0) {
              this.usersData[i].isState = this.$t(
                "permission_configuration_management.user.offLine"
              );
            }
            // 是否有效
            if (this.usersData[i].active) {
              this.usersData[i].isActive = this.$t(
                "permission_configuration_management.user.enable"
              );
            } else {
              this.usersData[i].isActive = this.$t(
                "permission_configuration_management.user.disable"
              );
            }
          }
        });
    },
    changePage: function(current) {
      this.current = current;
      tableUsersVue.getUsersData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableUsersVue.getUsersData();
    },
    // 销毁
    beforeDestroy: function() {
      eventBus.$off("userNames");
    },
    /**************************删除****************************/
    // 删除
    doDelete: function(index) {
      this.lineIndex = index;
      this.usersName = this.usersData[index].name;
    },
    removeUser: function() {
      var lineIndex = this.lineIndex;
      // 账户删除
      this.$api.user
        .deleteUser("id", this.usersData[lineIndex].id)
        .then(res => {
          this.modal_loading = true;
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            // 21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableUsersVue.getUsersData();
            this.modal_loading = false;
            this.usersDelmodal = false;
            this.$Message.success(this.$t("common.deleteSuccess"));
          }, 1000);
        });
    },
    /*****************************switch*************************/
    switch(index) {
      this.index = index;
      // 打开是true,启用0 禁用1
      if (this.usersData[index].active) {
        this.changeStatusMessage(
          this.usersData[index].id,
          this.usersData[index].name,
          this.usersData[index].role,
          this.usersData[index].email,
          "active",
          false
        );
      } else {
        this.changeStatusMessage(
          this.usersData[index].id,
          this.usersData[index].name,
          this.usersData[index].role,
          this.usersData[index].email,
          "active",
          true
        );
      }
    },
    // 更新反馈信息某一字段
    changeStatusMessage: function(id, name, role, email, key, value) {
      this.$api.user
        .updateUser({
          id: id,
          name: name,
          role: role,
          email: email,
          active: value
        })
        .then(res => {
          tableUsersVue.getUsersData();
        });
    },
    // 查询角色
    search: function(department) {
      this.$api.user.listRegisterInformation().then(res => {
        // 公司列表
        this.companyIdList = res.data.companies;
        // 部门列表
        this.departmentList = res.data.departments;
      });
      this.$api.user
        .listPositionByDepartment("departmentIndex", department)
        .then(res => {
          this.positionList = res.data;
        });
    },
    // 切换部门
    changeDepartment: function() {
      let department = this.userEditForm.department;
      if (department != undefined) {
        this.$api.user
          .listPositionByDepartment(
            "departmentIndex",
            this.userEditForm.department
          )
          .then(res => {
            this.positionList = res.data;
          });
      }
    },
    // 切换公司
    changeCompanyId: function() {
      this.userEditForm.role = "";
      if (this.userEditForm.companyId != undefined) {
        this.$api.user
          .queryRole("companyId", this.userEditForm.companyId)
          .then(res => {
            this.roleList = res.data;
          });
      }
    },
    // 重置密码
    /****************************************************/
    rowClick: function(row, index) {
      this.resetPasswordVisible = true;
      this.$nextTick(function() {
        this.$refs.resetPassword.getData(row, index);
      });
    },
    // 确定
    userSubmit: function(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          // 如果开启短信验证 手机号码为必填项
          this.userEditForm.mfaStatus =
            this.msgCode == this.$t("common.yes") ? 1 : 0;
          if (this.userEditForm.mfaStatus == 1) {
            if (!this.userEditForm.phone) {
              this.$Message.error(
                this.$t(
                  "permission_configuration_management.smsLogin.plaTelPhone"
                )
              );
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
              return;
            }
            // showcode为true 表示用户修改了手机号码 则进行验证码填写非空判断
            if (this.showCode) {
              if (!this.userEditForm.code) {
                this.$Message.error(
                  this.$t(
                    "permission_configuration_management.smsLogin.plaVerificationCode"
                  )
                );
                this.loading = false;
                this.$nextTick(() => {
                  this.loading = true;
                });
                return;
              }
            }
          }
          this.userSubmitData(name);
        } else {
          //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
          this.loading = false;
          setTimeout(() => {
            this.loading = true;
          }, 0);
          this.$Message.error(this.$t("common.editFail"));
        }
      });
    },
    userSubmitData(name) {
      this.$api.user
        .updateUser({
          id: this.userEditForm.id,
          name: this.userEditForm.name,
          email: this.userEditForm.email,
          position: this.userEditForm.position,
          department: this.userEditForm.department,
          fullName: this.userEditForm.fullName,
          companyId: this.userEditForm.companyId,
          role: this.userEditForm.role,
          active: this.userEditForm.active,
          mfaStatus: this.userEditForm.mfaStatus,
          phone: this.areaCode + "-" + this.userEditForm.phone,
          code: this.userEditForm.code
        })
        .then(res => {
          this.data = res.data;
          setTimeout(() => {
            tableUsersVue.showAll();
            this.loading = false;
            this.$nextTick(() => {
              this.loading = true;
            });
            this.$Message.success(this.$t("common.editSuccess"));
            this.usersEditmodal = false;
          }, 1000);
          clearInterval(this.run);
          this.disabled = false;
          this.text = this.$t(
            "permission_configuration_management.smsLogin.getVerificationCode"
          );
          //延时清空数据
          // setTimeout(() => {
          //   this.$refs[name].resetFields();
          // }, 2000);
          this.getErrMsg = "";
        })
        .catch(err => {
          this.getErrMsg = err.data || err.data.message;
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        });
    },
    // 取消
    userReset: function(name) {
      this.$refs[name].resetFields();
      clearInterval(this.run);
      this.disabled = false;
      this.text = this.$t(
        "permission_configuration_management.smsLogin.getVerificationCode"
      );
    },
    // 操作日志
    /****************************************************/
    logClick: function(row) {
      this.isShowOperationLog = true;
      this.$nextTick(function() {
        this.$refs.configurationManagementOperationLog.getConfigurationManagementOperationLogList(
          row.id,
          7
        );
      });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
.tel-container {
  display: flex;
  border: 1px solid #dcdee2;
  border-radius: 5px;
  width: 300px;
  align-items: center;
}
.tel-container >>> .ivu-input {
  border: none;
}
.tel-container >>> .ivu-select-single .ivu-select-selection {
  background: none;
  border: none;
  outline: none;
  border: none;
}
/* 去掉点击下拉框时的阴影 */
.tel-container >>> .ivu-select-single .ivu-select-selection:focus {
  box-shadow: 0 0 02px transparent;
}
.tel-container >>> .ivu-select-selected-value {
  color: #515a6e;
  text-align: center;
}
.tel-container
  >>> .ivu-select-single
  .ivu-select-selection
  .ivu-select-placeholder {
  color: #515a6e;
  text-align: center;
}
.tel-container >>> .ivu-select {
  width: 70px;
}
.tel-container >>> input::-webkit-outer-spin-button,
.tel-container >>> input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
.tel-container >>> input[type="number"] {
  -moz-appearance: textfield;
}
.btn-text {
  background: none;
}
.btn-text:hover {
  background: none;
}
/* 去掉点击下拉框时的阴影 */
.btn-text:focus {
  box-shadow: 0 0 0 2px transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/user/TableUsers.vue